<template>
  <div>
    <common-dialog ref="dialog" width="100%" title="选择查询方案">
      <div class="index-tree-box">
        <plan-tree ref="planTree" auto-h show-action @on-select="onSelect" @on-edit="onEdit" />
        <div class="right-box">
          <query-info ref="queryInfo" v-if="data.QueryPlanType==0" />
          <query-info2 ref="queryInfo2" v-else />
        </div>
      </div>
      <template slot="footer">
        <el-button type="primary" :loading="isLoading" @click="search">查 询</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import planTree from "./tree/index";
import queryInfo from "./queryInfo";
import queryInfo2 from "./queryInfo2";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    planTree,
    queryInfo,
    queryInfo2
  },
  data() {
    return {
      api: require("@/api/gd/queryplan").default,
      data: {
        QueryPlanId: 0,
        QueryPlanName: "",
        QueryPlanType: 0,
        TeacherId: 0,
      },
      isLoading: false,
    };
  },
  computed: {},
  methods: {
    getData() {
      this.$refs.planTree.getData();
    },
    onEdit(data) {
      this.api.info(data.QueryPlanId).then((res) => {
        this.$emit("on-edit", res.Data);
      });
    },
    onSelect(data) {
      console.log("选择方案", data);
      if (data) {
        this.data.QueryPlanId = data.QueryPlanId;
        this.data.QueryPlanName = data.QueryPlanName;
        this.data.QueryPlanType = data.QueryPlanType;
        this.data.TeacherId = data.TeacherId;
        this.api.info(data.QueryPlanId).then((res) => {
          if(res.Code==0) {
            if(data.QueryPlanType==0) {
              this.$refs.queryInfo.setData(res.Data);
            } else {
              this.$refs.queryInfo2.setData(res.Data);
            }
          }
        });
      } else {
        this.$refs.queryInfo.clear();
      }
    },
    search() {
      var result = {};
      if(this.data.QueryPlanType == 0) {
        result = this.$refs.queryInfo.getData();
        // console.log("result", JSON.parse(JSON.stringify(result)));
        if (Object.keys(result.data).length == 0) {
          this.$message.warning("请选择查询方案");
          return;
        }
        var sub = { ...this.data, Dts: result.dts };
        this.isLoading = true;
        this.api.save(sub).then((res) => {
          this.isLoading = false;
          if (res.Code == 0) {
            this.$emit("on-search", result.data);
            this.close(true);
          } else {
            this.$message.error("失败");
          }
        });
      } else {
        result = this.$refs.queryInfo2.getData();
        // console.log("result",result);
        // return;
        this.isLoading = true;
        this.api.save(result.data).then((res) => {
          this.isLoading = false;
          if (res.Code == 0) {
            this.$emit("on-search2", result.sub);
            this.close(true);
          } else {
            this.$message.error("失败");
          }
        });
      }
    },
  },
};
</script>